// extracted by css-extract-rspack-plugin
export default {"container":"DraftIssueTreeBlock-module__container__lCPtm"};